<template>
  <div style="display: none;"></div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: "GlobalMessage",
  methods: {
    ...mapMutations(['clearGlobalErrors', 'clearErrMsg']),
    resetMsg() {
      this.clearGlobalErrors();
    }
  }
};
</script>
